import { buttonVariants, Tooltip, TooltipContent, TooltipTrigger } from "@pdfking/components"
import type { ComponentProps } from "preact"

import { LANGUAGES } from "../i18n/Languages"
import { useTranslationTyped } from "../i18n/useTranslation"
import { Settings } from "../settings/Settings"

const FLAGS: Record<string, string> = { en: "🇬🇧", fr: "🇫🇷", it: "🇮🇹" }

// A button that's actually a native <select> underneath — the flag is just
// the trigger's face, same footprint (and same `side` default) as
// DarkModeSwitch. Like it, the language is the host's Settings, never the
// viewer's: the viewer only reads it back through the `lang` getter it was
// built with.
export function LanguageSwitch({
  side = "bottom",
}: {
  side?: ComponentProps<typeof TooltipContent>["side"]
}) {
  const pdfview = useTranslationTyped("pdfview")
  const lang = Settings.lang

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={buttonVariants({ className: "relative", size: "icon", variant: "ghost" })}>
          <span aria-hidden className="pointer-events-none text-base">
            {FLAGS[lang] ?? lang}
          </span>
          <select
            aria-label={pdfview.CHANGE_LANGUAGE()}
            className="absolute inset-0 cursor-pointer appearance-none opacity-0"
            onChange={e => (Settings.lang = e.currentTarget.value)}
            value={lang}
          >
            {LANGUAGES.map(l => (
              <option key={l} value={l}>
                {FLAGS[l]} {l.toUpperCase()}
              </option>
            ))}
          </select>
        </span>
      </TooltipTrigger>
      <TooltipContent align="center" side={side}>
        {pdfview.CHANGE_LANGUAGE()}
      </TooltipContent>
    </Tooltip>
  )
}
